export default __webpack_public_path__ + "static/media/Call.efd6754d.svg";